// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m-Epf","clinicsSelect":"styles_clinicsSelect__3Uba6"};